<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h4>
          {{ $t("headerDocTemplates") }}
          <a href="#"
            ><i
              class="bi bi-info-circle"
              data-toggle="modal"
              data-target="#infoModal"
              data-title="headerDocTemplates"
              data-body="docIdHeaderInfoBody"
              @click.prevent="showmodal"
            ></i
          ></a>
        </h4>
      </div>
      <div class="card-body">
        <form action="" id="DocumentTemplates" @submit.prevent>
          <div v-for="(item, index) in getDocumentIdType" :key="item">
            <div class="card-body border rounded mb-2">
              <div class="row mb-3">
                <div
                  class="mb-3 text-primary text-center"
                  v-if="!isDisabled(index)"
                >
                  {{ $t("Edit_Mode") }}
                </div>
                <label for="DomainID" class="col-sm-3 col-form-label"
                  >{{ $t("DomainID") }}:*
                  <a href="#"
                    ><i
                      class="bi bi-info-circle"
                      data-toggle="modal"
                      data-target="#infoModal"
                      data-title="DomainID"
                      data-body="
                        'docIdDomainIdInfoBody1'
                      "
                      @click.prevent="showmodal"
                    ></i></a
                ></label>
                <div class="col-sm-9">
                  <input
                    required
                    type="text"
                    class="form-control"
                    id="DomainID"
                    :disabled="isDisabled(index)"
                    :value="getDomainId(index)"
                    @input="changeDomainId(index, $event)"
                    @focusout="singleFault($event.target)"
                    @keydown.enter.prevent
                  />
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-sm-4">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      :checked="getIsPrimary(index)"
                      id="domainId-primary"
                      :disabled="isDisabled(index)"
                      @input="changeIsPrimary(index, $event)"
                    />
                    <label class="form-check-label" for="domainId-primary">
                      is primary:*
                      <a href="#"
                        ><i
                          class="bi bi-info-circle"
                          data-toggle="modal"
                          data-target="#infoModal"
                          data-title="thisTitle"
                          data-body="thisBody"
                          @click.prevent="showmodal"
                        ></i
                      ></a>
                    </label>
                  </div>
                </div>
              </div>
              <div class="row mb-3">
                <label for="DocumentDomainId" class="col-sm-3 col-form-label"
                  >{{ $t("DocumentDomainId") }}:*
                  <a href="#"
                    ><i
                      class="bi bi-info-circle"
                      data-toggle="modal"
                      data-target="#infoModal"
                      data-title="DocumentDomainId"
                      data-body="
                        'docIdDocDomainIdInfoBody1' 
                      "
                      @click.prevent="showmodal"
                    ></i></a
                ></label>
                <div class="col-sm-9">
                  <input
                    required
                    type="url"
                    class="form-control"
                    id="DocumentDomainId"
                    :value="getDocumentDomainId(index)"
                    :disabled="isDisabled(index)"
                    @input="changeDocumentDomainId(index, $event)"
                    @focusout="singleFault($event.target)"
                    @keydown.enter.prevent
                  />
                </div>
              </div>
              <div class="row mb-3">
                <label for="DocumentId" class="col-sm-3 col-form-label"
                  >{{ $t("DocumentID") }}:*
                  <a href="#"
                    ><i
                      class="bi bi-info-circle"
                      data-toggle="modal"
                      data-target="#infoModal"
                      data-title="DocumentID"
                      data-body="
                        'docIdDocIdInfoBody1' 
                      "
                      @click.prevent="showmodal"
                    ></i></a
                ></label>
                <div class="col-sm-9">
                  <input
                    required
                    type="url"
                    class="form-control"
                    id="DocumentId"
                    :value="getDocumentId(index)"
                    @input="changeDocumentId(index, $event.target.value)"
                    @focusout="checkDocId($event.target)"
                    @keydown.enter.prevent
                  />
                </div>
              </div>
              <div class="row mb-3">
                <div
                  class="col-sm-12 text-end mt-1"
                  v-if="
                    !(getDocumentIdTypeId(index) == undefined) && !getNextRound
                  "
                >
                  <a href="#">
                    <i
                      class="bi bi-trash icon-secondary"
                      data-toggle="modal"
                      data-target="#confirmDeleteModal"
                      @click.prevent="showDeleteModal(index)"
                    ></i
                  ></a>
                  <span class="text-secondary">
                    {{ $t("delete_template") }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="
              (getDocumentIdType.length == 1 ||
                getDocumentIdType.length == 0) &&
              !getNextRound
            "
          >
            <h5 v-if="getDocumentIdType.length == 1">
              {{ $t("headerAddDocId") }}
            </h5>
            <!-- <h5 v-else></h5> -->
            <div class="card-body border rounded mt-2 border-dark">
              <div class="row mb-3">
                <label for="Template" class="col-sm-3 col-form-label"
                  >{{ $t("chooseTemp") }}
                </label>
                <div class="col-sm-9">
                  <select
                    :required="
                      getDocumentIdType.length == 0 &&
                      getUserChooseTemplate == 0
                    "
                    class="form-select"
                    id="DocTemplate"
                    v-model="docTemplates.id"
                    @change.prevent="setDocTemplate(docTemplates.id)"
                    @focusout="singleFault($event.target)"
                    @keydown.enter.prevent
                  >
                    <option
                      v-for="item in docTemplates"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.DomainId }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="row mb-3">
                <div class="row mb-3">
                  <h3 class="text-primary">{{ $t("or") }}</h3>
                </div>
                <div class="col-lg-3 col-form-label">
                  {{ $t("createTemp") }}
                </div>
                <div class="col-lg-3">
                  <button
                    class="btn btn-outline-primary"
                    style="width: 8rem"
                    @click.prevent="addDocumentIdType"
                  >
                    <i class="bi-plus-circle" style="font-size: 1.5rem"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-sm-8 align-left mt-2">
              <go-back-util />
            </div>
            <div class="col-sm-4 align-right mt-2">
              <button
                class="btn btn-success bi-caret-right"
                @click.prevent="createDocIdTemplate"
              >
                {{ $t("next Step") }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <modal-utils />
    <div
      class="modal fade"
      id="confirmDeleteModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="confirmDeleteModalTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="confirmDeleteModalTitle"></h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body"></div>
          <div class="modal-footer justify-content-between">
            <button
              type="button"
              class="btn btn-secondary float-start"
              data-dismiss="modal"
            >
              {{ $t("cancel") }}
            </button>
            <button
              type="button"
              class="btn btn-primary float-end"
              data-dismiss="modal"
              @click="deleteTemplate(delIndex)"
            >
              {{ $t("delete_template") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import axios from "axios";
import GoBackUtil from "../utils/GoBackUtil.vue";
import { mapActions, mapGetters } from "vuex";
import Fault from "../utils/Fault";
import i18n from "@/i18n";
import ModalUtils from "../utils/ModalsUtils.vue";
// import JSZip from "jszip";
export default {
  name: "DocumentIdCom",
  data() {
    return {
      docTemplates: [],
      fail: [],
      delIndex: undefined,
    };
  },
  methods: {
    checkDocId(ele) {
      const faultCode = this.singleFault(ele);
      if (!faultCode) {
        this.deletePrimaryFault(i18n.global.t("faultMandatory"));
        this.fail.push(i18n.global.t("faultMandatory"));
      } else {
        this.deletePrimaryFault(i18n.global.t("faultMandatory"));
      }
      this.pushAlert();
    },
    pushAlert() {
      if (this.fail.length > 0) {
        let Message = "";
        this.fail.forEach(function (item) {
          Message = Message + item + "\n";
        });
        alert(Message);
      }
    },
    singleFault(ele) {
      return Fault.singleFault(ele);
    },
    setUserActed(action) {
      this.$store.dispatch("DocId/setUserChooseTemplate", action);
    },
    setDocTemplate(key) {
      var docTemplate = this.docTemplates.find(function (element) {
        return element.id == key;
      });
      let payload = {
        index: this.getDocumentIdType.length,
        DocumentIdTyp: docTemplate,
      };
      this.$store.dispatch("DocId/addDocumentIdType");
      this.$store.dispatch("DocId/setDocumentIdType", payload);
      this.setUserActed(1);
    },
    isDisabled(index) {
      if (this.getNextRound) {
        return true;
      } else {
        return false;
      }
    },
    changeDocumentId(index, value) {
      let payload = {
        index: index,
        DocumentId: value,
      };
      this.$store.dispatch("DocId/setDocumentId", payload);
    },
    changeDomainId(index, event) {
      let payload = {
        index: index,
        DomainId: event.target.value,
      };
      this.$store.dispatch("DocId/setDomainId", payload);
    },
    changeDocumentDomainId(index, event) {
      let payload = {
        index: index,
        DocumentDomainId: event.target.value,
      };
      this.$store.dispatch("DocId/setDocumentDomainId", payload);
    },
    changeIsPrimary(index) {
      this.deletePrimaryFault();
      var primary = !this.getIsPrimary(index);
      let payload = {
        index: index,
        IsPrimary: primary,
      };
      this.$store.dispatch("DocId/setIsPrimary", payload);
      var isPrimary = this.checkIsPrimary();
      if (isPrimary != 1) {
        this.fail.push(i18n.global.t("faultIsPrimary" + isPrimary));
        this.pushAlert();
      }
    },
    deletePrimaryFault(faultValue) {
      var index = this.fail.indexOf(faultValue);
      if (index !== -1) {
        this.fail.splice(index, 1);
      }
    },
    checkIsPrimary() {
      var isPrimaryCounter = 0;
      this.getDocumentIdType.forEach((element) => {
        if (element.IsPrimary) {
          isPrimaryCounter++;
        }
      });
      return isPrimaryCounter;
    },
    deleteTemplate(index) {
      this.docTemplates.splice(this.getDocumentIdTypeId(index), 1)
      this.$store.dispatch("DocId/removeDocumentIdType", index);
      this.createCookie()
      this.setUserActed(0);
      if (this.$cookies.isKey("DocIdTemplate")) {
        this.docTemplates = this.$cookies.get("DocIdTemplate");
      } else {
        this.docTemplates = [];
      }
    },

    createCookie() {
      for (let i = 0; i < this.getDocumentIdType.length; i++) {
        if (this.getDocumentIdTypeId(i) !== undefined) {
          this.setDocumentTypeId(i);
          this.docTemplates[i] = {
            DomainId: this.getDomainId(i),
            IsPrimary: this.getIsPrimary(i),
            DocumentDomainId: this.getDocumentDomainId(i),
            id: i,
          };
        } else {
          this.setDocumentTypeId(i);
          this.docTemplates.push({
            DomainId: this.getDomainId(i),
            IsPrimary: this.getIsPrimary(i),
            DocumentDomainId: this.getDocumentDomainId(i),
            id: i,
          });
        }
      }
      this.$cookies.set("DocIdTemplate", this.docTemplates);
    },

    createDocIdTemplate() {
      this.deletePrimaryFault(i18n.global.t("faultMandatory"));
      if (!Fault.faultControl(document)) {
        this.fail.push(i18n.global.t("faultMandatory"));
      }
      this.deletePrimaryFault(i18n.global.t("faultIsPrimary0"));
      this.deletePrimaryFault(i18n.global.t("faultIsPrimary2"));
      var isPrimary = this.checkIsPrimary();
      if (isPrimary != 1) {
        this.fail.push(i18n.global.t("faultIsPrimary" + isPrimary));
      }
      if (this.fail.length == 0) {
        if (this.getCookieStatus == "accept" && !this.getNextRound) {
          this.createCookie()
        }
        this.$router.push("/metadata/classification");
        this.$store.dispatch("ActSteps/setClassification", true);
      } else this.pushAlert();
    },

    ...mapActions("DocId", [
      "setUserChooseTemplate",
      "setDomainId",
      "setIsPrimary",
      "setDocumentDomainId",
      "setDocumentIdType",
      "setDocumentId",
      "addDocumentIdType",
      "removeDocumentIdType",
      "setDocumentTypeId",
    ]),
    ...mapActions("ActSteps", ["setClassification"]),
    ...mapActions("DocVer", ["setDocVersionId4"]),
    showmodal() {
      $("#infoModal").on("show.bs.modal", function (event) {
        var button = $(event.relatedTarget);
        var title = button.data("title");
        var body = button.data("body");
        var modal = $(this);
        modal.find(".modal-title").text(i18n.global.t(title));
        modal.find(".modal-body").text(i18n.global.t(body));
      });
    },
    showDeleteModal(index) {
      this.delIndex = index;
      $("#confirmDeleteModal").on("show.bs.modal", function (event) {
        var title = "delete_template";
        var body = "reallyDelete";
        var modal = $(this);
        modal.find(".modal-title").text(i18n.global.t(title));
        modal.find(".modal-body").text(i18n.global.t(body));
      });
    },
  },
  components: {
    GoBackUtil,
    ModalUtils,
  },
  computed: {
    ...mapGetters("DocId", [
      "getUserChooseTemplate",
      "getDomainId",
      "getIsPrimary",
      "getDocumentDomainId",
      "getDocumentIdType",
      "getDocumentId",
      "getDocumentIdTypeInstance",
      "getDocumentIdTypeId",
    ]),
    ...mapGetters(["getNextRound", "getCookieStatus"]),
    ...mapGetters("Files", ["getFileArray", "getPdfFile"]),
  },
  //
  activated() {
    if (this.$cookies.isKey("DocIdTemplate")) {
      this.docTemplates = this.$cookies.get("DocIdTemplate");
    }
  },
};
</script>

<style scoped>
.col-form-label {
  padding-top: 0rem;
}
.icon-secondary {
  color: #6c757d;
  padding-right: 0.5rem;
}
</style>
